export default "__VITE_ASSET__DQbexA4v__"